
let header = {
  headers: {
    appId:'boriumweb',
    appKey: 'iasofjsovsdlvsdvlsnflsfhuawefawefnwaeflnjnv-=sf',
    "Content-Type": "application/json",
  }
}
let boriumUrl = 'https://posapi.boriumstudio.com/';
// let boriumDbUrl = 'http://10.0.100.3:9090/api/public/'
const axios = require('axios');

export function getBranches(groupId) {
  return new Promise(function(resolve, reject) {
    let url = boriumUrl + 'webGroups.php?subscription_id='+ groupId;
    // console.log("URL to get merchant " + url);

    // EventBus.$emit('showLoading', true, "Getting Restaurant")
    axios.get(url, header)
      .then(function(response){
        // EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getMerchant(merchantId, type = null) {
  return new Promise(function(resolve, reject) {
    let url = boriumUrl + 'web_merchant.php?merchantId='+ merchantId;
    // console.log("URL to get merchant " + url);

    // EventBus.$emit('showLoading', true, "Getting Restaurant")
    axios.get(url, header)
      .then(function(response){
        // EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/borium.js